import { render } from "./QuickStartView.vue?vue&type=template&id=5000469b&scoped=true"
import script from "./QuickStartView.vue?vue&type=script&lang=js"
export * from "./QuickStartView.vue?vue&type=script&lang=js"

import "./QuickStartView.vue?vue&type=style&index=0&id=5000469b&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5000469b"]])

export default __exports__